import angular from 'angular'

import railwayCtrl from './railway.controller'
import railwayRoutes from './railway.routes'
import railwayRun from './railway.run'

const name = 'routingConsultRailway'

angular.module(name, [])
  .controller('railwayCtrl', railwayCtrl)
  .config(railwayRoutes)
  .run(railwayRun)

export default name



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/railway/railway.module.js